import { KatLitFilteredElement, register } from '../../shared/base';
import { KatMetric } from '.';

/**
 * @component {kat-metric-amount} KatMetricAmount Component used to place and filter amount within the metric component.
 */
@register(KatMetric.slotMapping.amount.name)
export class KatMetricAmount extends KatLitFilteredElement {
  constructor() {
    super(
      KatMetric.slotMapping.amount.name,
      KatMetric.slotMapping.amount.allowed
    );
  }
}
